module.exports = __webpack_public_path__ + "img/logo2 copy.c9e64c64.svg";